import { getGFT, postGFT, delGFT } from '@/common/utils/ajax'
import { DEFAULT_PER } from '@/config'

const getConsultantFeeds = (params) => getGFT('v1/blogs', {
    ...params,
    per: DEFAULT_PER,
})
const initFeedEdit = (id) => {
    const params = {}
    if (id) {
        params.building_id = id
    }
    return getGFT(`v1/blogs/new`, params )
}
const addBlog = (params) => postGFT('v1/blogs', params)

const delBlog = (id) => delGFT(`v1/blogs/${id}`)

const stickyFeed = id => postGFT(`v1/blogs/${id}/sticky`)

export default {
    addBlog,
    delBlog,
    stickyFeed,
    getConsultantFeeds,
    initFeedEdit
}